import React from 'react';
import { useTheme } from 'styled-components';

/* Styled Components */
import { StyledCheckbox } from 'styles/common/WishCheckBox';

/* Child Components */
import CheckIcon from 'icons/CheckIcon';

const CHECKBOX_SIZE = {
  DEFAULT: 16,
  LARGE: 20,
} as const;

type PropsType = {
  dataID?: number;
  large?: boolean;
  isChecked: boolean;
  onCheck?: (arg0: boolean, arg1: number | null | undefined) => void;
  isDisabled?: boolean;
  position?: string;
  overrideStyle?: React.CSSProperties;
  iconToBoxMargin?: number;
};

const Checkbox = ({
  dataID,
  large,
  isChecked,
  onCheck,
  isDisabled,
  position,
  overrideStyle,
  iconToBoxMargin = 2,
}: PropsType) => {
  const theme = useTheme();

  const size = large ? CHECKBOX_SIZE.LARGE : CHECKBOX_SIZE.DEFAULT;
  const onClick = () => {
    if (!isDisabled && onCheck) {
      onCheck(!isChecked, dataID);
    }
  };

  return (
    <StyledCheckbox
      width={`${size}px`}
      height={`${size}px`}
      isDisabled={isDisabled}
      onClick={onClick}
      isChecked={isChecked}
      position={position}
      style={overrideStyle}
      role="checkbox"
      aria-checked={isChecked}
    >
      {isChecked && (
        <CheckIcon
          overrideStyle={{
            width: `${size - iconToBoxMargin * 2}px`,
            height: `${size - iconToBoxMargin * 2}px`,
            color: theme.white,
            margin: `${iconToBoxMargin}px`,
          }}
        />
      )}
    </StyledCheckbox>
  );
};

export default Checkbox;
